
import * as antd from 'antd';
import { LoadingOutlined, PlusOutlined, PushpinFilled, SendOutlined } from '@ant-design/icons';

import {ChatEnquiringPill, ChatPill} from '../../app/components/chatPill';
import styled from 'styled-components';
import { Button, Drawer, Space, Spin } from 'antd';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setEnquireText, setMessages } from './querySlice';
import { enquireChat, getChat, getPinnedMessages, pinMessage, startNewChat } from './queryThunk';
import logo from '../../images/nexaid_logo.png';
import { useLoaderData } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { get } from 'http';


const ChatWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    flex: 1 1 auto;
`
const MessageBar = styled.div`
    padding: 10px;
    display: flex;
    flex: 0 0 auto;
`

const ChatHeader = styled.div`
    padding: 10px;
    display: flex;
    flex: 0 0 auto;
    justify-content: end;
`

const ChatIcons = styled.div`
    align-items: right;
`

const NoMessageWrapper = styled.div`
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; 
    font-size: 1.5em;
    color: #888;
    text-align: center;
`

const ChatLogo = styled.img`
    width: 300px;
    max-width: 60%;
    padding: 20px;
    border-radius: 50%;
    object-fit: cover;
    height: 300px;
`

const MotivationList = [
    "Got a hunch? Ask away and uncover the story behind your numbers!",
    "Your next big insight is one question away — dive in now!",
    "Turn data into direction — ask a question to unlock the 'why'.",
    "Don't just look at the dashboard — explore it, question it, own it.",
]
export default function Query() {
    const dispatch = useAppDispatch();
    const [openPinned, setOpenPinned] = useState(false);
    const onClosePinned = () => {
        setOpenPinned(false);
    }

    const messages = useAppSelector(state => state.query.messages);
    const pinnedMessages = useAppSelector(state => state.query.pinnedMessages);
    const loadingChat = useAppSelector(state => state.query.loadingChat);
    const loadingPinned = useAppSelector(state => state.query.loadingPinned);

    const isEnquiring = useAppSelector(state => state.query.isEnquiring);
    const enquireText = useAppSelector(state => state.query.enquireText);

    useEffect(() => {
        dispatch(getChat());
    }, [dispatch]);

    return (<div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', height: '100%' }}>
        <ChatHeader>
            <ChatIcons>
                <Button type="default"
                    onClick={() => {
                        dispatch(getPinnedMessages());
                        setOpenPinned(true)
                    }}
                    style={{ marginRight: 8 }}>
                    <PushpinFilled /> View Saved
                </Button>
                <Button type="default" onClick={() => {
                    if (!isEnquiring) {
                        dispatch(startNewChat({}))
                    }
                }} disabled={isEnquiring}>
                    <PlusOutlined /> New Chat
                </Button>
            </ChatIcons>
        </ChatHeader>
        {messages.length ?
            <ChatWrapper ref={el => {
                if (el) {
                    el.scrollTop = el.scrollHeight;
                }
            }}>
                {messages.map((msg, index) => (
                    <ChatPill 
                        key={index} 
                        userPill={msg.role === 'user'} 
                        text={msg.content} 
                        pinned={msg.pinned}
                        onPin={() => {
                            dispatch(pinMessage({chatId: msg.chatId, messageTs: msg.ts, pinState: !msg.pinned}))
                        }}
                    />
                ))}
                {isEnquiring && <ChatEnquiringPill />}
            </ChatWrapper>
            : loadingChat? 
            <Spin percent="auto" indicator={<LoadingOutlined spin />} size="large" /> :
            <NoMessageWrapper>
                <ChatLogo src={logo} />
                {MotivationList[Math.floor(Math.random() * MotivationList.length)]}
            </NoMessageWrapper>
        }
        <MessageBar>
            <antd.Input
                placeholder="Ask me about your business..."
                style={{ flex: 1, marginRight: 8 }}
                value={enquireText}
                onChange={(e) => {
                    dispatch(setEnquireText(e.target.value))
                }}
                onPressEnter={() => {
                    if (enquireText.trim() && !isEnquiring) {
                        dispatch(enquireChat({message: enquireText.trim() }))
                    }
                }}
                disabled={isEnquiring}
            />
            <antd.Button
                type="primary"
                onClick={() => {
                    if (enquireText.trim() && !isEnquiring) {
                        dispatch(enquireChat({message: enquireText.trim() }))
                    }
                }}
                disabled={isEnquiring || !enquireText.trim()}
                loading={isEnquiring}
            >
                Enquire<SendOutlined />
            </antd.Button>
        </MessageBar>
        <Drawer
            title="Your Save Results"
            placement="right"
            width={500}
            onClose={onClosePinned}
            open={openPinned}
        >
            <ChatWrapper>
                {pinnedMessages.length ?
                    pinnedMessages.map((msg, index) => (
                        <ChatPill
                            key={index}
                            userPill={msg.role === 'user'}
                            text={msg.content}
                            pinned={msg.pinned}
                            onPin={() => {
                                dispatch(pinMessage({ chatId: msg.chatId, messageTs: msg.ts, pinState: !msg.pinned }))
                                .then(() => {dispatch(getPinnedMessages())});
                            }}
                        />
                    ))
                    : loadingPinned ?
                        <Spin percent="auto" indicator={<LoadingOutlined spin />} size="large" /> :
                        <NoMessageWrapper>
                            You have not saved any messages yet.
                        </NoMessageWrapper>
                }
            </ChatWrapper>
        </Drawer>
    </div>

    )

}

